import React from 'react'
import { Route, Redirect, useHistory } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux";
import Cookies from 'js-cookie'
import { logout } from "./redux/actions"
export const PrivateRoute = ({ component: Component, access, roles, path, socket, ...rest }) => {
  // alert(JSON.stringify(socket))
  let loggedInUser = useSelector((state) => state.userDetails.isLoggedIn);
  let user = useSelector((state) => state.userDetails.user);
  const history = useHistory();
  var validate = false;
  const dispatch = useDispatch()

  if (!Cookies.get('token') || !user.is_active) {
    dispatch(logout())
  }

  if (access == false) {
    if (Cookies.get('token') && loggedInUser) {
      if (user && (roles.indexOf(user.role[0]) > -1)) {
        validate = true;
      }
      else {
        validate = false;
        return (<Route  {...rest} render={props => history.push("/dashboard")} />)
      }
    }
    else {
      validate = false;
    }
  }
  else if (path == '/login' || path == '/sign-up') {
    if (Cookies.get('token') && loggedInUser) {
      return (<Route  {...rest} render={props => history.push("/dashboard")} />)

    }

  }

  return (<Route
    {...rest}
    render={props =>
      (access || validate) === true ? (<Component {...props} socket={socket} />) : history.push("/login")
    } />
  )

}